(() => {
  const rowTolerance = 4;
  let frame = null;

  const visibleHeight = (element) => {
    if (!element) return 0;
    const rect = element.getBoundingClientRect();
    return rect.width && rect.height ? rect.height : 0;
  };

  const reset = (card) => {
    [
      '.card__heading',
      '.card-information',
      '.price',
      '.product-card-options',
      '.product-card-options__group',
      '.card > .card__content',
    ].forEach((selector) => {
      card.querySelectorAll(selector).forEach((element) => {
        element.style.minHeight = '';
      });
    });
  };

  const getParts = (card) => {
    const content = card.querySelector('.card > .card__content');
    const heading = card.querySelector('.card > .card__content .card__heading');
    const information = card.querySelector('.card > .card__content .card-information');
    const price = card.querySelector('.card > .card__content .price');
    const options = card.querySelector('.product-card-options');
    const groups = Array.from(card.querySelectorAll('.product-card-options__group')).sort((a, b) => {
      const orderA = Number.parseInt(window.getComputedStyle(a).order || '0', 10);
      const orderB = Number.parseInt(window.getComputedStyle(b).order || '0', 10);
      if (orderA !== orderB) return orderA - orderB;
      return Number(a.dataset.optionIndex || 0) - Number(b.dataset.optionIndex || 0);
    });

    return { content, heading, information, price, options, groups };
  };

  const rowsFor = (cards) => {
    const rows = [];

    cards.forEach((card) => {
      const top = card.getBoundingClientRect().top;
      let row = rows.find((candidate) => Math.abs(candidate.top - top) <= rowTolerance);

      if (!row) {
        row = { top, cards: [] };
        rows.push(row);
      }

      row.cards.push(card);
      row.top = Math.min(row.top, top);
    });

    return rows;
  };

  const setRowHeights = (row) => {
    const parts = row.cards.map(getParts);
    const maxHeading = Math.max(...parts.map(({ heading }) => visibleHeight(heading)), 0);
    const maxPrice = Math.max(...parts.map(({ price }) => visibleHeight(price)), 0);
    const maxInformation = Math.max(...parts.map(({ information }) => visibleHeight(information)), 0);
    const groupCount = Math.max(...parts.map(({ groups }) => groups.length), 0);
    const maxGroups = Array.from({ length: groupCount }, (_, index) =>
      Math.max(...parts.map(({ groups }) => visibleHeight(groups[index])), 0)
    );

    parts.forEach(({ heading, price, information, groups }) => {
      if (heading && maxHeading) heading.style.minHeight = `${Math.ceil(maxHeading)}px`;
      if (price && maxPrice) price.style.minHeight = `${Math.ceil(maxPrice)}px`;
      if (information && maxInformation) information.style.minHeight = `${Math.ceil(maxInformation)}px`;
      groups.forEach((group, index) => {
        if (maxGroups[index]) group.style.minHeight = `${Math.ceil(maxGroups[index])}px`;
      });
    });

    const maxContent = Math.max(...parts.map(({ content }) => visibleHeight(content)), 0);
    parts.forEach(({ content }) => {
      if (content && maxContent) content.style.minHeight = `${Math.ceil(maxContent)}px`;
    });
  };

  const align = () => {
    frame = null;
    const cards = Array.from(document.querySelectorAll('.product-card-wrapper .card')).filter((card) => {
      const rect = card.getBoundingClientRect();
      return rect.width && rect.height;
    });

    cards.forEach(reset);
    rowsFor(cards).forEach(setRowHeights);
  };

  const schedule = () => {
    if (frame) window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => window.requestAnimationFrame(align));
  };

  const watchImages = (root = document) => {
    root.querySelectorAll('.product-card-wrapper img').forEach((image) => {
      if (!image.complete) image.addEventListener('load', schedule, { once: true });
    });
  };

  window.MariashopAlignProductCards = schedule;

  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('mariashop:facets-rendered', schedule);
  document.addEventListener('mariashop:card-options-updated', schedule);

  document.addEventListener('DOMContentLoaded', () => {
    schedule();
    window.setTimeout(schedule, 250);
    window.setTimeout(schedule, 900);
    watchImages();

    const grid = document.getElementById('ProductGridContainer') || document.body;
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) watchImages(node);
      }));
      schedule();
    }).observe(grid, { childList: true, subtree: true });
  });
})();
